import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import { useGetEquipment } from "../api/api";
import { MainMenuToolbar } from "../components/MainMenuToolbar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { CardActionArea, Fab } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import formatStaticEquipment from "../helpers/formatStaticEquipment";
import type { ShipRouteProps } from "../types/routes";
import type { StaticEquipment } from "../types/models";

export const StaticEquipments = (props: ShipRouteProps) => {
  const shipId = props.match.params.shipId;

  const { data: equipment = [] } = useGetEquipment(shipId) as {
    data: StaticEquipment[];
  };

  const filtered = equipment.filter(
    (item) => item.type === "winch" || item.type === "mooring_bit"
  );

  return (
    <div>
      <MainMenuToolbar title="Static Equipments" />
      <Container maxWidth="sm">
        <Grid container spacing={2} sx={{ mt: 1, pb: 5 }}>
          {filtered.map((item) => {
            return (
              <Grid key={item.id} item xs={12}>
                <StaticEquipmentCard item={item} shipId={shipId} />
              </Grid>
            );
          })}
        </Grid>
      </Container>
      <Link to={`/ships/${shipId}/static-equipments/new/`}>
        <Fab
          color="primary"
          aria-label="add"
          sx={{ position: "fixed", zIndex: 1, bottom: 16, right: 24 }}
        >
          <AddIcon />
        </Fab>
      </Link>
    </div>
  );
};

const StaticEquipmentCard = ({
  item,
  shipId
}: {
  item: StaticEquipment;
  shipId: string;
}) => {
  return (
    <Link to={`/ships/${shipId}/static-equipments/${item.id}/edit/`}>
      <Card>
        <CardActionArea>
          <CardContent>
            <Typography component="div">{formatStaticEquipment(item)}</Typography>
            <Typography variant="body2" color="text.secondary">
              Deck position: {item.position_on_deck?.x}, {item.position_on_deck?.y}
            </Typography>
            {item.type === "winch" && (
              <Typography variant="body2" color="text.secondary">
                Mooring lines: {(item.cables || []).map((cable) => cable.tag).join(", ") || "-"}
              </Typography>
            )}
          </CardContent>
        </CardActionArea>
      </Card>
    </Link>
  );
};
